<template>
    <section class="cinema-detail">
        <div class="cinema-box">
            <i class="close" @click="closeCinemaDetail()"></i>
            <div v-if="hMoviesDetails">
                <div style="position: realtive;">
                    <img width="100%" src="@/assets/images/home/opacity.png" />
                    <img class="t-o" src="@/assets/images/home/opacf2.png" />
                    <img class="i-c" :class="{'oct': isvis}" width="100%" :src="hMoviesDetails.cover ?
                        hMoviesDetails.cover : require('@/assets/images/movies/Default_cover.png')"
                    />
                </div>
                <div class="btn-group">
                    <a class="play" href="javascript:void(0);"
                        @click="switchCinemaHandler(hMoviesDetails.id, hMoviesDetails.member_type)"
                    >
                        <img src="@/assets/images/home/top_play.png" />{{ $t('home.1') }}
                    </a>
                    <!-- <img class="add-list" src="@/assets/images/home/add_list.png"
                        @click.stop="addListsHandler(hMoviesDetails.id)"
                    /> -->
                </div>
                <div v-if="hMoviesDetails.preview_url && hMoviesDetails.preview_url[0]" class="hvideo-box" v-show="isvis">
                    <video ref="player"
                        class="video-js player"
                        :id="`video${hMoviesDetails.id}`"
                        x5-playinline="true" webkit-playsinline='true'
                        playsinline='true' x-webkit-airplay='true'
                        x5-video-player-type='h5' x5-video-player-fullscreen='true'
                        x5-video-ignore-metadata='true'
                    ></video>
                </div>
            </div>
        </div>

        <!-- H5 播放按钮 -->
        <div class="play_btn_h5">
            <div class="play_h5" @click="switchCinemaHandler(hMoviesDetails.id, hMoviesDetails.member_type)">
                {{ $t('home.1') }}
            </div>
        </div>
        <div class="cinema-cont" v-if="hMoviesDetails">
            <div class="ci-info">
                <h4>
                    <p class="title">{{ hMoviesDetails.name }}</p>
                </h4>
                <p class="desc">
                    {{ hMoviesDetails.desc }}
                </p>
                <ul class="tags">
                    <li v-for="(item, index) in hMoviesDetails.tag" :key="index">{{ item.name }}</li>
                </ul>
                <p class="attrs attrs11">
                    <span>{{ $t('serial.1') }}: </span>
                    <span>{{ hMoviesDetails.duration }}</span>
                </p>
                <p class="attrs">
                    <span>{{ $t('serial.2') }}: </span>
                    <span>{{ hMoviesDetails.year_shooting }}</span>
                </p>
                <p class="attrs" v-if="hMoviesDetails.serial_num">
                  <span>{{ $t('serial.13') }}: </span>
                  <span>{{ hMoviesDetails.serial_num }}</span>
                </p>
            </div>
            <div class="c-panel">
                <div class="title">
                    <i></i>{{ $t('serial.4') }}
                </div>
                <ul class="actor-ul clearfix">
                    <li v-for="(item, index) in hMoviesDetails.actor" :key="index">
                        <img :src="item.img" />
                        <p>{{ item.name }}</p>
                    </li>
                </ul>
            </div>
            <div class="c-panel" v-if="moviesSimilar.length > 0">
                <div class="title">
                    <i></i>{{ $t('serial.6') }}
                </div>
                <ul class="ci-ul clearfix">
                    <li v-for="(item,index) in moviesSimilar"
                        :key="index"
                        @click="switchCinemaHandler(item.movie_id, item.member_type)"
                    >
                        <div class="img-box">
                            <span class="subscript-tag" v-if="item.is_subscript == 1"></span>
                            <img class="ci-cover" :src="item.cover ?
                                item.cover : require('@/assets/images/movies/Default_cover.png')"
                            />
                            <div class="line-box">
                                <img src="@/assets/images/home/play.png" />
                                <!-- <img src="@/assets/images/home/add_list.png"
                                    @click.stop="addListsHandler(item.movie_id)"
                                /> -->
                            </div>
                        </div>
                        <p class="title">{{ item.name }}</p>
                        <p class="desc">{{ item.desc }}</p>
                    </li>
                </ul>
            </div>
        </div>

    </section>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
    name: "TopSwiper",
    data() {
        return {
            options: {},
            player: null,
            timer: null,
            isvis: false,
        };
    },
    computed: {
        ...mapState({
            hMoviesDetails: (state) => state.home.hMoviesDetails,
            moviesSimilar: (state) => state.serial.moviesSimilar,
            userMember: (state) => state.home.userMember
        }),
    },
    async mounted(){
        const mid = window.localStorage.getItem("mid");

        // this.SetLoadStatusFn({loadStatus: true});
        const res = this.FetchMovieSimpleFn({id: mid});
        const res1 = await this.FetchHmovieDetailsFn({ id: mid });
        const res2 = await this.getMoviesimilarFn({ id: mid });
        // this.SetLoadStatusFn({loadStatus: false});
        // console.log('详情弹框', this.hMoviesDetails)

        if(this.hMoviesDetails.preview_url && this.hMoviesDetails.preview_url[0]){
            this.$nextTick(() => { this.initHandler() });
        }

    },
    methods: {
        ...mapActions({
            FetchHmovieDetailsFn: "FetchHmovieDetailsFn",
            getMoviesimilarFn: "getMoviesimilarFn",
            getMovieepisodeFn: "getMovieepisodeFn",
            SetCininfoStatusFn: "SetCininfoStatusFn",
            SetLoadStatusFn: "SetLoadStatusFn",
            getAddPlayListFn: "getAddPlayListFn",
            SetCoverStatusFn: "SetCoverStatusFn",
            SetSiginStatusFn: "SetSiginStatusFn",
            SetLoadShowFn: "SetLoadShowFn",
            addLoadShowFn:"addLoadShowFn",
            SetCininfoStatusH5Fn: "SetCininfoStatusH5Fn",
            FetchMovieSimpleFn: "FetchMovieSimpleFn",
            getDataNikkatsuFn: "getDataNikkatsuFn"
        }),
        initHandler(){
            this.options = this.$utils.initOptions(
                this.hMoviesDetails.preview_url[0],
                true,
                true
            );
            this.timer = setTimeout(() => {
                this.isvis = true;
                this.player = this.$video(`video${this.hMoviesDetails.id}`, this.options);
            }, 3000);
        },
        async addListsHandler(mid){

            if(window.localStorage.getItem("token")){
               this.SetLoadStatusFn({loadStatus: true});
                const result = await this.getAddPlayListFn({mid: String(mid)});
                this.SetLoadStatusFn({loadStatus: false});
            }else{
                this.$message.warning(this.$t('account.7'));
            }
        },
        switchCinemaHandler(mid, member_type){
            this.closeCinemaDetail();
            // 发送统计上报
            const sendDataNikkatsuFn = async() => {
                const result = await this.getDataNikkatsuFn( {up_type: 6} );
            }
            sendDataNikkatsuFn();

            if(!window.localStorage.getItem("token")){
                window.localStorage.setItem('path', `/serial/${mid}?pid=${mid}`);
                this.SetSiginStatusFn(true);
                return;
            }
            if((Object.keys(this.userMember).length > 0 && this.userMember.isVip == 1) || member_type == 1) {
                this.SetLoadShowFn(false);
                this.addLoadShowFn(true).then(res => {
                this.$router.push('/serial/' + mid + '?pid=' + mid);
                })
            } else {
                this.$router.push("/member");
            }
        },
        closeCinemaDetail(){
            this.SetCininfoStatusFn(false);
            this.SetCininfoStatusH5Fn(false);
            this.$store.commit('SET_HMOVIES_DETAILS', {});
            this.$store.commit('SET_MOVIES_SIMILAR', {});
        }
    },
    destroyed(){
        if(this.player){
            this.player.dispose();
        }
    }

}
</script>
<style lang="scss" scoped>

@media screen and (min-width:1367px) {
    .play_btn_h5{
        display: none;
    }
    .cinema-cont .c-panel .ci-ul li:nth-of-type(3n){ margin-right: 0;}
    .cinema-cont .c-panel .actor-ul li:nth-of-type(5n){ margin-right: 0;}
}
@media only screen  and (min-width : 769px)and (max-width:1366px) {
    .play_btn_h5{
        display: none;
    }
    .cinema-cont .c-panel .ci-ul li:nth-of-type(3n){ margin-right: 0;}
    .cinema-cont .c-panel .actor-ul li:nth-of-type(5n){ margin-right: 0;}

}
@media screen and (max-width:768px) {
    .cinema-detail {
        width: 100%;
        margin-left: 0;
        left: 0;
        bottom: 1px;
    }
    .cinema-detail .t-o {
        opacity: 0;
    }
    .cinema-box .btn-group{
        display: none;
    }

    .play_btn_h5{
        display: block;
        width: 100%;
        margin: 10px 0 0 0;
        .play_h5{
            width: 89.33%;
            height: 37px;
            margin: 0 auto;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #FF0000;
            border-radius: 2px;
            font-size: 15px;
            color: #FFFFFF;
        }
    }
    .cinema-cont{
        padding: 15px 15px;
    }
    .cinema-cont h4 {
        // margin-bottom: 15px;
        font-size: 18px;
        color: #FFFFFF;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
    }
    .cinema-cont h4 .title {
        width: 100%;
        max-width: 100%;
    }
    .cinema-cont h4 span {
        display: none;
    }
    .cinema-cont .tags{
        margin-top: 10px;
    }
    .cinema-cont .tags li {
        width: 48px;
        height: 26px;
        line-height: 26px;
        padding: 0 10px;
    }

    .cinema-cont .attrs.attrs11{
        margin-top: 10px;
    }

    .cinema-cont .attrs{
        margin-top: 2px;
    }

    .cinema-cont .attrs span {
        font-size: 12px;
        line-height: 24px;
        color: #BCBCBC;
    }
    .cinema-cont .c-panel {
        margin-top: 20px;
    }
    .cinema-cont .c-panel .title{
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 10px;
    }
    .cinema-cont .c-panel .title i{
        display: none;
    }

    .cinema-cont .c-panel .ci-ul li {
        width: 100%;
        margin-bottom: 8px;
        padding-bottom: 5px;
        margin-right: 2%;
    }
    .cinema-cont .c-panel .actor-ul li {
        width: 32%;
    }
    .cinema-cont .c-panel .ci-ul li:nth-of-type(2n) {
        margin-right: 0;
    }
    .cinema-cont .c-panel .actor-ul li:nth-of-type(3n) {
        margin-right: 0;
    }
    .cinema-cont .c-panel .ci-ul li p.title {
        font-size: 16px;
        line-height: 21px;
        margin-top: 8px;
    }
    .cinema-cont .c-panel .ci-ul li p.desc{
        font-size: 12px;
        line-height: 21px;
        margin-top: 4px;
    }
    .cinema-cont .c-panel .ci-ul li .ci-cover{
      object-fit: cover;
      width: 100%;
      height: 210px
    }
    .cinema-box .close {
        width: 24px;
        height: 24px;
        background:url("@/assets/images/home/close2_h5.png") no-repeat 0 0;
        background-size: 100% 100%;
        top: 10px;
    }
    .cinema-cont .desc {
        font-size: 12px;
        line-height: 16px;
        color: #A4A4A4;
    }

}

</style>
